import { BlobServiceClient } from '@azure/storage-blob';

// const sasTokenAutos =  window.sessionStorage.getItem("STORAGE_SASTOKEN_AUTOS");
// const sasTokenPublicacao = window.sessionStorage.getItem("STORAGE_SASTOKEN_PUBLI");
// const storageAccountName = window.sessionStorage.getItem("STORAGE_ACCOUNTNAME");

function setContainerClient(containerName) {
    let storageAccountName = window.sessionStorage.getItem("STORAGE_ACCOUNTNAME");
    let sasToken;
    if(containerName == 'autos')
      sasToken = window.sessionStorage.getItem("STORAGE_SASTOKEN_AUTOS");//sasToken = sasTokenAutos;
    else if(containerName == 'publicacoes')
      sasToken = window.sessionStorage.getItem("STORAGE_SASTOKEN_PUBLI");//sasToken = sasTokenPublicacao;
    
    // get BlobService = notice `?` is pulled out of sasToken - if created in Azure portal
    const blobService = new BlobServiceClient(
      `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`
  );
  
  console.log('blobService', blobService);
    // get Container - full public read access
    const containerClient = blobService.getContainerClient(containerName);
    return containerClient;

}

// return list of blobs in container to display
export const getBlobsInContainer = async (containerName, containerClient, listAll) => {
  const returnedBlobUrls = [];
  let storageAccountName = window.sessionStorage.getItem("STORAGE_ACCOUNTNAME");

  if(containerClient == null)
    containerClient = setContainerClient(containerName);

  if(listAll)
  {
    for await (const blob of containerClient.listBlobsFlat()) {
      returnedBlobUrls.push(`https://${storageAccountName}.blob.core.windows.net/${containerName}/${blob.name}`);
    }
  }
  else
  {
    // get list of blobs in container  
    for await (const blob of containerClient.listBlobsByHierarchy("/")) { //listBlobsFlat(): lista todos itens do container, incluindo childs 
      // if image is public, just construct URL
      returnedBlobUrls.push(`https://${storageAccountName}.blob.core.windows.net/${containerName}/${blob.name}`);
    }    
  }

  return returnedBlobUrls;
};

const createBlobInContainer = async (containerClient, file) => {
  
  // create blobClient for container
  const blobClient = containerClient.getBlockBlobClient(file.name);

  // set mimetype as determined from browser with file upload control
  const options = { blobHTTPHeaders: { blobContentType: file.type } };

  // upload file
  await blobClient.uploadBrowserData(file, options);
  await blobClient.setMetadata({UserName : 'blopsleads_webapp'});
};

const uploadFileToBlob = async (file, containerName) => {
  if (!file) return [];

  const containerClient = setContainerClient(containerName);

  // upload file
  await createBlobInContainer(containerClient, file);

  // get list of blobs in container
  return getBlobsInContainer(containerName, containerClient);
};

export default uploadFileToBlob;